/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {ADN_TARGETING_TYPES, SPECIAL_NO_CATEGORY_TARGET} from '../targeting-constants';
import {TargetingHelper} from '../targeting-helper';
import {convertIabCategoryToString} from '../../../components/util/iab-taxonomy';

import template from './category-summary.component.html';

@Component({
  standalone: false,
  selector: 'adn-targeting-category-summary',
  template
})
export class CategorySummaryComponent implements OnChanges {
  @Input() targets: any;

  data: any[] | any = [];
  isComplex = false;
  restricted = false;
  showOnly = 2;
  quantity = 2;

  ngOnChanges(): void {
    const targets = this.targets || {};
    this.isComplex = TargetingHelper.isComplex(targets, ADN_TARGETING_TYPES.category.id);

    if (this.isComplex) {
      this.data = [];
      _.forEach(targets, (entryObj) => {
        const inputted: any[] = [];
        const notInputted: any[] = [];
        _.forEach(entryObj.categories, (k) => {
          let vk = k;
          let isNot = _.startsWith(vk.toUpperCase(), 'NOT ');
          if (vk === SPECIAL_NO_CATEGORY_TARGET) {
            vk = 'Front Page';
          }
          if (vk === ('NOT ' + SPECIAL_NO_CATEGORY_TARGET)) {
            vk = 'NOT Front Page';
            isNot = false;
          }
          inputted.push({k: convertIabCategoryToString(isNot ? vk.substr(4).split('|').join(', ') : vk.split('|').join(', ')), not: isNot});
        });
        _.forEach(entryObj.notCategories, (k) => {
          const isNot = _.startsWith(k.toUpperCase(), 'NOT ');
          notInputted.push({k: convertIabCategoryToString(isNot ? k.substr(4).split('|').join(', ') : k.split('|').join(', ')), not: isNot});
        });
        this.data.push({categories: inputted, notCategories: notInputted});
      });
    } else {
      const modelData: {model: any; inputted?: any} = {model: targets};
      TargetingHelper.simpleInit(modelData, 'categories');
      const displayData = _.cloneDeep(modelData.inputted);

      const value = displayData.value.split(', ');
      const valueAll = displayData.valueAll.split(', ');
      const valueNotAny = displayData.valueNotAny.split(', ');

      const maxEntries = 30;
      this.restricted = false;
      if ((value.length + valueAll.length + valueNotAny.length) > maxEntries) {
        const sliceNumberValue = Math.min(value.length, maxEntries);
        displayData.shortValue = value.slice(0, sliceNumberValue).join(', ');

        const sliceNumberValueAll = Math.max(Math.min(valueAll.length, maxEntries - sliceNumberValue), 0);
        displayData.shortValueAll = valueAll.slice(0, sliceNumberValueAll).join(', ');

        const sliceNumberValueNotAny = Math.max(Math.min(valueNotAny.length, maxEntries - (sliceNumberValueAll + sliceNumberValue)), 0);
        displayData.shortValueNotAny = valueNotAny.slice(0, sliceNumberValueNotAny).join(', ');

        this.restricted = true;
      }

      _.forEach(targets, (t) => {
        _.forEach(t.categories, (c) => {
          if (c === SPECIAL_NO_CATEGORY_TARGET) {
            displayData.frontPage = 'Front Page';
          }
          if (c === ('NOT ' + SPECIAL_NO_CATEGORY_TARGET)) {
            displayData.frontPage = 'NOT Front Page';
          }
        });
      });
      this.data = displayData;
    }
    this.quantity = this.showOnly;
  }

  switchUp(): void {
    if (this.quantity === this.showOnly) {
      this.quantity = this.data.length;
      return;
    }
    this.quantity = this.showOnly;
  }

  showAll(): void {
    this.restricted = false;
  }
}
